import React, { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import styled from "@emotion/styled";
import {
  POLICY_STATUS_DELETED,
  POLICY_STATUS_EDIT,
} from "../Constants/PolicyTranslationConstants";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal",
    textOverflow: "clip",
    fontWeight: "bold",
    lineHeight: "1",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: 0,
    paddingLeft: theme.spacing(1),
    maxHeight: "32px",
  },
  "& .css-1essi2g-MuiDataGrid-columnHeaderRow": {
    padding: 0,
    maxHeight: "32px",
  },
  "& .readOnlyTranslation": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "& .deletedRuleTranslation": {
    backgroundColor: "rgba(253, 199, 5, 0.5)",
    "&:hover": {
      backgroundColor: "rgba(253, 199, 5, 0.5)",
    },
  },
  "& .stripedRowTranslation": {
    backgroundColor: theme.palette.dataGrid.rowOddBackgroundColor,
    "&:hover": {
      backgroundColor: theme.palette.dataGrid.rowOddBackgroundColor,
    },
  },
  "& .validationError": {
    border: "1px solid red",
    color: "red",
  },
}));

function PolicyRulesDataGrid({
  gridHeight = 300,
  setLoading,
  initialState,
  rows,
  columns,
  editable,
  ...other
}) {
  useEffect(() => {
    if (setLoading && rows.length >= 0) {
      setLoading(false);
    }
  }, [setLoading]);

  return (
    <StyledDataGrid
      initialState={{
        ...initialState,
        pagination: { paginationModel: { pageSize: 25 } },
      }}
      sx={{
        maxHeight: `${gridHeight}px !important `,
        "& .MuiDataGrid-cell": {
          display: "flex",
          alignItems: "center",
        },
      }}
      pageSizeOptions={[10, 25, 50]}
      rows={rows}
      columns={columns}
      rowHeight={40}
      showCellVerticalBorder={true}
      showColumnVerticalBorder={true}
      disableColumnFilter={true}
      disableRowSelectionOnClick={true}
      isCellEditable={(params) =>
        (params.row.RuleHeader.EditRule ?? "").toUpperCase() !==
          POLICY_STATUS_EDIT &&
        editable &&
        (params.row.RuleHeader.EditRule ?? "").toUpperCase() !==
          POLICY_STATUS_DELETED
      }
      {...other}
      getRowClassName={(params) => {
        let classes = !editable ? "readOnlyTranslation" : "";
        if (
          (params.row.RuleHeader.EditRule ?? "").toUpperCase() ===
          POLICY_STATUS_DELETED
        ) {
          classes += " deletedRuleTranslation";
        } else if (params.indexRelativeToCurrentPage % 2 === 0) {
          classes += " stripedRowTranslation";
        }
        return classes;
      }}
    />
  );
}

export default PolicyRulesDataGrid;
